// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bz_c0","select":"bz_D","icon":"bz_dQ","block":"bz_cY"};